import { shapeAspectRatio, type ShapeProps } from './shapes'
import { cn } from '../lib/utils'

export type { ShapeGeometry, ShapeProps } from './shapes'

export function Shape({
  shape,
  className,
  width,
  height,
  'aria-label': label,
  'aria-hidden': hidden = !label,
  focusable = false,
  ...props
}: ShapeProps) {
  return (
    <svg
      viewBox={shape.viewBox}
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('block h-auto w-full shrink-0 transition-colors', className)}
      style={{ aspectRatio: shapeAspectRatio(shape), width, height }}
      aria-label={label}
      aria-hidden={hidden}
      role={label ? 'img' : undefined}
      focusable={focusable}
      {...props}
    >
      <path d={shape.path} fill="currentColor" fillRule={shape.fillRule} clipRule={shape.fillRule} />
    </svg>
  )
}
